import { Row, Col, Button, Form, notification, DatePicker, Switch, message } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";

import endpoints from "../../utils/endpoints.js";
import { DeleteOutlined } from "@ant-design/icons";

function SettingsCountdown({ data }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (data.length > 0) {
      let auxData = data.filter((item) => item.name === "countdown")[0];
      auxData.json = JSON.parse(auxData.json);
      auxData.json.date = auxData.json.date ? dayjs(auxData.json.date) : null;
      console.log(auxData.json);
      form.setFieldsValue(auxData.json);
    }
  }, [data]);

  function handleSubmit(values) {
    setIsButtonLoading(true);

    values.date = dayjs(values.date).format("YYYY-MM-DD HH:mm:ss");
    axios
      .post(endpoints.settings.update, {
        data: { values, name: "countdown" },
      })
      .then((resData) => {
        setIsButtonLoading(false);
        message.success("Definições foram editadas com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function handleWarningMissingFields() {
    message.error("Faltam alguns campos para preencher!");
  }

  return (
    <div className="dashboard-page">
      <div className="dashboard-content-row">
        <Form form={form} layout="vertical" onFinish={handleSubmit} onFinishFailed={handleWarningMissingFields} initialValues={{ event_days: [{}] }}>
          <div className="grid grid-cols-2 gap-4">
            <Form.Item name="date" label="Data/Hora" rules={[{ required: true, message: "Este é um campo obrigatório" }]} className="!w-full">
              <DatePicker size="large" showTime className="!w-full" />
            </Form.Item>
            <Form.Item label="Ativo" name="is_active" valuePropName="checked">
              <Switch />
            </Form.Item>
          </div>
          <Button type="primary" size="large" onClick={form.submit} loading={isButtonLoading}>
            Guardar
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default SettingsCountdown;
